module.exports = __webpack_public_path__ + "img/åke_johnsson.3e004a2f.png";